import { combineReducers } from 'redux';
import {
  UPSERT_ABLOY_KEY,
  KEY_IS_BUSSY,

  ADD_LEASE_KEY_TO_RECEIVED,
  ADD_LEASE_KEY_TO_GIVEN,
  RECEIVED_LEASE_KEY,
  NOT_RECEIVED_LEASE_KEY,
  LOOSE_LEASE_KEY,
  BROKEN_LEASE_KEY,
  RETURN_LEASE_KEY,
  REMOVE_LEASE_KEY,

  SET_KEY_UPDATING_STATUS_BY_ID,
  SET_KEY_UPDATING_STATUS_BY_STAMP,

  FETCH_RECEIVED_KEYS,
  FETCH_GIVEN_KEYS,
  FETCH_LOST_KEYS,
  FETCH_BROKEN_KEYS,
} from '../actions';

const abloyKeysReducer = (abloyKeys = null, action) => {
  switch (action.type) {
    case UPSERT_ABLOY_KEY:
      return upsertAbloyKey(abloyKeys, action.payload);
    case KEY_IS_BUSSY:
      return updateAbloyKeyIsBusy(abloyKeys, action.identity, action.busy);
  }

  return abloyKeys
};

const receivedKeysReducer = (receivedKeys = [], action) => {

  switch (action.type) {
    case FETCH_RECEIVED_KEYS:
      return lodash.orderBy(action.payload, 'stamp');
      //lease keys
    case ADD_LEASE_KEY_TO_RECEIVED:
      return addApartmentKey(receivedKeys, action.payload);
    case RECEIVED_LEASE_KEY:
      return markApartmentKeyAsReceived(receivedKeys, action.payload);
    case NOT_RECEIVED_LEASE_KEY:
      return markApartmentKeyAsNotReceived(receivedKeys, action.payload);
    case RETURN_LEASE_KEY:  // mark state returned in list
      return markApartmentKeyAsReturned(receivedKeys, action.payload);
    case REMOVE_LEASE_KEY:
      return removeApartmentKey(receivedKeys, action.payload);
    default:
      return lodash.orderBy(receivedKeys, 'stamp');
  }
};

const givenKeysReducer = (givenKeys = [], action) => {

    switch (action.type) {
      case FETCH_GIVEN_KEYS:
        return lodash.orderBy(action.payload, 'stamp');
      //lease keys
      case ADD_LEASE_KEY_TO_GIVEN:
        return addApartmentKey(givenKeys, action.payload);
      case RECEIVED_LEASE_KEY:
        return markApartmentKeyAsReceived(givenKeys, action.payload);
      case NOT_RECEIVED_LEASE_KEY:
        return markApartmentKeyAsNotReceived(givenKeys, action.payload);
      case RETURN_LEASE_KEY:  // mark state returned in list
        return markApartmentKeyAsReturned(givenKeys, action.payload);
      case REMOVE_LEASE_KEY:
        return removeApartmentKey(givenKeys, action.payload);
      default:
        return lodash.orderBy(givenKeys, 'stamp');
    }

};

const lostKeysReducer = (lostKeys = [], action) => {
  switch (action.type) {
    case FETCH_LOST_KEYS:
      return action.payload;
    case LOOSE_LEASE_KEY:
      return addLostKey(lostKeys, action.payload);
    default:
      return lostKeys
  }
};

const brokenKeysReducer = (brokenKeys = [], action) => {
  switch (action.type) {
    case FETCH_BROKEN_KEYS:
      return action.payload;
    case BROKEN_LEASE_KEY:
      return addBrokenKey(brokenKeys, action.payload);
    default:
      return brokenKeys
  }
};

const updatingKeysReducer = (updatingKeys = [], action) => {
  switch (action.type) {
    case FETCH_GIVEN_KEYS:
    case FETCH_RECEIVED_KEYS:
      return initApartmentKeyUpating(updatingKeys, action.payload)
    case SET_KEY_UPDATING_STATUS_BY_ID:
      return setApartmentKeyUpdatingStatus(updatingKeys, action.payload)
    case SET_KEY_UPDATING_STATUS_BY_STAMP:
      return setApartmentKeyUpdatingStatusByStamp(updatingKeys, action.payload)
    default:
      return updatingKeys
  }
}

const reducers = {
  // ## Reducers ##
  abloyKeys   : abloyKeysReducer,
  receivedKeys: receivedKeysReducer,
  givenKeys   : givenKeysReducer,
  lostKeys    : lostKeysReducer,
  brokenKeys  : brokenKeysReducer,
  updatingKeys: updatingKeysReducer,
};

const appReducer = combineReducers(reducers);

export default appReducer;

function addApartmentKey(apartmentKeys, key) {
  let newKeys = lodash.cloneDeep(apartmentKeys);
  if (!newKeys) { newKeys = [] }
  if (!key) { return newKeys }

  newKeys.push(key)

  return lodash.orderBy(newKeys, 'stamp');
}

function markApartmentKeyAsNotReceived(apartmentKeys, apartmentKeyId) {
  return setApartmentKeyState(apartmentKeys, apartmentKeyId, 'not_received')
}

function markApartmentKeyAsReceived(apartmentKeys, apartmentKeyId) {
  return setApartmentKeyState(apartmentKeys, apartmentKeyId, 'received')
}

function markApartmentKeyAsReturned(apartmentKeys, apartmentKeyId) {
  return setApartmentKeyState(apartmentKeys, apartmentKeyId, 'returned')
}

function setApartmentKeyState(apartmentKeys, apartmentKeyId, newState) {
  const newKeys = lodash.cloneDeep(apartmentKeys)
  const apartmentKey = lodash.find(newKeys, (item) => item.id == apartmentKeyId)

  if (!apartmentKey) { return newKeys }

  apartmentKey.state = newState

  return newKeys
}

function initApartmentKeyUpating(updatingKeys, apartmentKeys) {
  let newKeys = lodash.cloneDeep(updatingKeys)
  if (!newKeys) { newKeys = [] }
  newKeys = newKeys.concat(apartmentKeys.map(({id, stamp}) => { return { id: id, stamp: stamp, updating: false } }))

  return newKeys
}

function setApartmentKeyUpdatingStatus(updatingKeys, { apartmentKeyId, stamp, updating }) {
  const newKeys = lodash.cloneDeep(updatingKeys)
  const keyForUpdate = lodash.find(newKeys, (item) => item.id == apartmentKeyId)

  if (!keyForUpdate) {
    newKeys.push({ id: apartmentKeyId, stamp: stamp, updating: updating})
    return newKeys
  }

  keyForUpdate.updating = updating

  return newKeys
}

function setApartmentKeyUpdatingStatusByStamp(updatingKeys, { apartmentKeyId, stamp, updating }) {
  const newKeys = lodash.cloneDeep(updatingKeys)
  const keysForUpdate = lodash.filter(newKeys, (item) => item.stamp == stamp)

  if (keysForUpdate.length == 0) {
    newKeys.push({ id: apartmentKeyId, stamp: stamp, updating: updating})
    return newKeys
  }

  keysForUpdate.forEach((key) => key.updating = updating)

  return newKeys
}

function removeApartmentKey(apartmentKeys, apartmentKeyId) {
  const newKeys = lodash.cloneDeep(apartmentKeys);
  lodash.remove(newKeys, item => {
    return item.id === apartmentKeyId
  });
  return lodash.orderBy(newKeys, 'stamp');
}

/* lost keys */
function addLostKey(lostKeys, key) {
  const newKeys = lodash.cloneDeep(lostKeys);
  if (key && key.stamp) {
    key.state = 'lost'
    newKeys.push(key)
  }
  return lodash.orderBy(newKeys, 'stamp')
}

/* broken keys */
function addBrokenKey(brokenKeys, key) {
  const newKeys = lodash.cloneDeep(brokenKeys);
  if (key && key.stamp) {
    key.state = 'broken'
    newKeys.push(key)
  }
  return lodash.orderBy(newKeys, 'stamp')
}

/* abloy keys */

function upsertAbloyKey(abloyKeys, key) {
  let newKeys = lodash.cloneDeep(abloyKeys)
  if (!newKeys) { newKeys = [] }
  if (!key) { return newKeys }

  lodash.remove(newKeys, item => { return item.identity === key.identity })
  newKeys.push(key)

  return newKeys
}

function updateAbloyKeyIsBusy(abloyKeys, identity, isBusy) {
  const newKeys = lodash.cloneDeep(abloyKeys);
  if (identity) {
    const abloyKey = lodash.find(newKeys, item => {
      return item.identity === identity
    });
    if (abloyKey) {
      abloyKey.is_busy = isBusy;
    }
  }
  return newKeys
}
